import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { P as O } from "./picker-button-Cfkqdcrg.mjs";
import { F as R } from "./flex-Cc3osQLf.mjs";
import { f as n } from "./index-LyFokDcn.mjs";
import { m as T } from "./tss-DN0acMKN.mjs";
import { useState as H, useCallback as l, useMemo as P } from "react";
import { M as W } from "./menu-63UgiRJf.mjs";
import { B as N } from "./button-CUHBhgeQ.mjs";
const V = T()(({ palette: e, typography: r, mixins: t }) => {
  var o;
  return {
    currencyButton: {
      // Need to increase specificity because the Button styles are overriding these styles
      "&&": {
        color: n.ifFeature("encore", e.gray[600], e.grey[900]),
        border: "none",
        borderLeft: n.ifFeature("encore", void 0, `1px solid ${e.grey[100]}`),
        fontSize: (o = r == null ? void 0 : r.teenie) == null ? void 0 : o.fontSize,
        fontWeight: n.ifFeature("encore", void 0, r.fontWeightRegular),
        height: "100%",
        lineHeight: n.ifFeature("encore", r.teenie.lineHeight),
        fontFamily: r.fontFamily,
        padding: n.ifFeature("encore", "0", "0 5px"),
        borderRadius: n.ifFeature("encore", 8),
        minWidth: n.ifFeature("encore", "54px"),
        maxWidth: n.ifFeature("encore", "54px"),
        "&:disabled": {
          border: "none",
          borderLeft: n.ifFeature("encore", void 0, `1px solid ${e.grey[100]}`),
          backgroundColor: n.ifFeature("encore", e.gray[50])
        },
        "&:focus": {
          background: "white !important",
          borderLeft: n.ifFeature("encore", void 0, "1px solid transparent !important"),
          boxShadow: n.ifFeature("encore", `0 0 0 4px ${t.alpha(e.primary.main, 0.1)}`)
        },
        "&:hover": {
          background: e.grey[100],
          border: "none",
          borderLeft: n.ifFeature("encore", void 0, `1px solid ${e.grey[100]}`),
          boxShadow: n.ifFeature("encore", `0 0 0 1px ${e.gray[400]}`, "none")
        }
      }
    },
    focusVisible: {
      borderLeft: n.ifFeature("encore", void 0, "1px solid transparent !important")
    }
  };
}), D = (e, r) => {
  const [t, o] = H(!1), a = l(() => {
    o(!0), e && typeof e == "function" && e();
  }, [e]), s = l(() => {
    o(!1), r && typeof r == "function" && r();
  }, [r]);
  return { open: t, handleOpen: a, handleClose: s };
}, J = 4;
function p(e, r) {
  return { items: [], type: e, key: r };
}
const U = (e) => P(() => {
  const t = [p("group", "most_common"), p("group", "rest")];
  return e.forEach((o, a) => {
    const s = a < J ? 0 : 1;
    t[s].items.push({
      key: o.code,
      text: o.text || `${o.code} - ${o.name}`,
      value: o.code,
      disabled: o.disabled || !1,
      data: o
    });
  }), t;
}, [JSON.stringify(e)]), _ = (e) => {
  switch (e) {
    case "teenie":
      return "small";
    case "small":
      return "small";
    case "medium":
      return "medium";
    case "large":
      return "large";
    case "biggie":
      return "large";
    default:
      return "medium";
  }
};
function ee(e) {
  const {
    biId: r,
    buttonProps: t,
    currencyCollection: o,
    disabled: a,
    name: s,
    onChange: b,
    onMenuClose: g,
    onMenuOpen: x,
    renderToggle: c,
    size: h = "medium",
    status: F,
    value: u,
    variant: y
  } = e, { classes: d } = V(), { open: C, handleOpen: S, handleClose: M } = D(x, g), v = U(o), k = ({ isFocused: m }, f) => {
    if (c && typeof c == "function")
      return c();
    const {
      "aria-expanded": j,
      "aria-haspopup": I,
      "aria-label": L,
      "data-menu-id": $,
      onBlur: w,
      onClick: z,
      onFocus: B,
      ref: E
    } = f;
    return n.ifFeature(
      "encore",
      /* @__PURE__ */ i.jsx(
        O,
        {
          ariaExpanded: j.toString(),
          ariaHaspopup: I.toString(),
          ariaLabel: L,
          biId: r,
          containerRef: E,
          "data-fabric-component": "CurrencyPicker",
          dataMenuId: $,
          disabled: a,
          focused: m,
          onBlur: w,
          onClick: z,
          onFocus: B,
          size: _(h),
          status: F,
          variant: y,
          children: u
        }
      ),
      /* @__PURE__ */ i.jsx(
        N,
        {
          ...f,
          classes: {
            focusVisible: d.focusVisible
          },
          className: d.currencyButton,
          "data-bi-id": r,
          disabled: a,
          focused: m,
          tabindex: -1,
          type: "button",
          variant: "outlined",
          ...t,
          children: u
        }
      )
    );
  };
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(R, { alignItems: "stretch", "data-component-name": "CurrencyInputMenu", "data-currency-code": u, height: "100%", children: /* @__PURE__ */ i.jsx(
      W,
      {
        isDisabled: a,
        isOpen: C,
        items: v,
        onClose: M,
        onOpen: S,
        onSelect: b,
        placement: {
          align: "start",
          side: "bottom"
        },
        renderToggle: k,
        showSearch: "never"
      }
    ) }),
    s && /* @__PURE__ */ i.jsx("input", { className: "currencyType js-currency-picker-type", name: s, type: "hidden", value: u })
  ] });
}
export {
  ee as C
};
//# sourceMappingURL=currency-picker-BHeMYSQ_.mjs.map
